<template>
	<div
		class="sticky-summary bg-white"
		id="sticky-summary"
		style="display: none; opacity: 0"
		ref="sticky-summary"
	>
		<div class="py-2 shadow-3">
			<div class="container d-flex d-lg-none flex-column mb-2">
				<span
					class="1"
					v-for="(prest, prest_i) in selectedPrestations"
					:key="prest_i"
				>
					<strong>{{ prest.quantity }} x </strong
					>{{ prest.prestation.prestName }}
				</span>
			</div>
			<div class="container d-flex justify-content-around">
				<div
					class="col-lg-7 d-none d-lg-flex flex-row nowrap align-items-center"
				>
					<div class="col-3 text-center px-0 heading text-grey-900">
						{{ content.planningSummary_yourSelection }}
					</div>
					<div
						class="prestations-list col-7 d-flex flex-column px-2 align-items-start"
					>
						<span
							class="text-start body text-grey-900"
							v-for="(prest, prest_i) in selectedPrestations"
							:key="prest_i"
						>
							{{ prest.quantity }} x {{ prest.prestation.prestName }}
						</span>
					</div>
					<div class="col-2 text-center px-0">
						<ParticipantsTotals
							:participants="participants"
							:content="content"
							:additionalClasses="'body text-grey-900'"
						/>
					</div>
				</div>
				<div
					class="col-12 col-lg-5 px-0 d-flex flex-row nowrap justify-content-between"
				>
					<div
						class="p-0 d-flex align-items-center justify-content-center justify-content-lg-end pe-2"
					>
						<Prices
							:isLoading="pricesLoadingSet.has(currentCacheKey)"
							:maxPromo="totals.maxPromo"
							:crossedPrice="totals.crossedPrice"
							:totalPrice="totals.totalPrice"
							:perPrice="totals.perPrice"
							:locale="locale"
						/>
					</div>
					<div
						class="col-5 col-sm-6 ps-md-0 text-center d-flex align-items-center justify-content-center"
					>
						<div class="w-100 d-flex align-items-center justify-content-center">
							<button
								@click.stop="handleReserveClick"
								class="button-primary primary-normal w-100 d-flex flex-row nowrap align-items-center justify-content-center"
							>
								<span class="buttons-default px-3 px-md-1">{{
									content.planner_resumeOrder
								}}</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Prices from "@/vue/planning/components/common/prices.vue"
import ParticipantsTotals from "@/vue/planning/components/common/participantsTotals.vue"
import { mapState, mapGetters } from "vuex"
import { elementInViewport } from "@/utils/utils"
import store from "@/vue/planning/store/store"
import pricesLoadingSet from "@/vue/planning/state/pricesLoadingSet"
import currentCacheKey from "@/vue/planning/computed/currentCacheKey"

// Tracking
import trackReservationClick from "@/tracking/trackReservationClick"

export default {
	store,
	name: "StickySummary",
	components: {
		Prices,
		ParticipantsTotals,
	},
	data() {
		return {
			pricesLoadingSet,
			currentCacheKey,
		}
	},
	computed: {
		...mapState(["content", "participants"]),
		...mapGetters([
			"totalSelectedHebergements",
			"totals",
			"selectedPrestations",
			"locale",
		]),
	},
	methods: {
		fadeIn(display = "block") {
			this.$refs["sticky-summary"].style.opacity = 0
			this.$refs["sticky-summary"].style.display = display
			this.$nextTick(() => {
				this.$refs["sticky-summary"].style.opacity = 1
			})
		},
		fadeOut() {
			this.$refs["sticky-summary"].style.opacity = 0
			setTimeout(() => {
				this.$refs["sticky-summary"].style.display = "none"
			}, this.speed)
		},
		handleReserveClick() {
			this.$store.dispatch("reserveClick")

			const {
				quantity,
				liheId,
				liheName,
				duration,
				beginDate,
				endDate,
				prestationsIds,
				prestationsNames,
				totalPrice,
				station,
				region,
			} = getReservationClickData()

			trackReservationClick(
				"book",
				quantity,
				prestationsIds,
				prestationsNames,
				totalPrice,
				beginDate,
				endDate,
				duration,
				liheId,
				liheName,
				station,
				region
			)
		},

		activateScrollListener() {
			document.addEventListener("scroll", () => {
				if (!this.$refs["sticky-summary"]) return
				const summary = document.querySelector("#summary")
				const footer = document.querySelector("footer")
				if (
					summary &&
					(elementInViewport(summary) || elementInViewport(footer))
				) {
					if (this.$refs["sticky-summary"].style.display !== "none") {
						this.fadeOut()
					}
				} else {
					if (this.$refs["sticky-summary"].style.display === "none") {
						if (this.totalSelectedHebergements === 0) return
						this.fadeIn()
					}
				}
			})
		},
		decideShowOrHideStickySummary(
			newTotalSelectedHebergements,
			oldTotalSelectedHebergements
		) {
			const summary = document.querySelector("#summary")

			if (
				newTotalSelectedHebergements > 0 &&
				oldTotalSelectedHebergements === 0
			) {
				if (summary && elementInViewport(summary)) return
				this.fadeIn()
			} else if (
				newTotalSelectedHebergements === 0 &&
				oldTotalSelectedHebergements > 0
			) {
				this.fadeOut()
			}
		},
	},
	watch: {
		totalSelectedHebergements: function (newValue, oldValue) {
			this.decideShowOrHideStickySummary(newValue, oldValue)
		},
	},
	mounted() {
		if (this.totalSelectedHebergements) {
			this.fadeIn()
		}
		this.activateScrollListener()
	},
}
</script>

<style scoped>
#sticky-summary {
	position: fixed;
	left: 0px;
	bottom: 0px;
	width: 100%;
	z-index: 1000;
	transition: opacity 250ms ease-in-out;
}
</style>
